/**
 * @module mapbs.components.editlink.editlink
 */
import angular from 'angular';
import './editlink.scss';

const moduleEditlink = angular.module('mapbsEditlinkModule', []);

moduleEditlink.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/editlink', require('./editlink.html'));
    }
);

/** @type {!angular.Component} */
const EditlinkComponent = {
    controller: 'MapbsEditlinkController as ctrl',
    templateUrl: 'mapbs/editlink',
    bindings: {
        'editlinkActive': '<mapbsEditlinkActive',
        'editlinkFunctionality': '<mapbsEditlinkFunctionality',
        'editlinkName': '<mapbsEditlinkName',
        'editlinkBaseurl': '<mapbsEditlinkBaseurl',
        'editlinkUrl': '<mapbsEditlinkUrlextension',
        'gmfUser': '<mapbsAuthenticationUser'
    },
};

moduleEditlink.component('mapbsEditlink', EditlinkComponent);

class EditlinkController {
    /**
   * @constructor
   * @param {angular.Scope} $scope
   * @param {angular.$injector} $injector
   * @private
   * @ngInject
   */
    constructor($scope, $injector) {
        this.scope = $scope;

        this.location = $injector.get('ngeoLocation');

        /** @type {boolean} */
        this.editlinkActive;

        /** @type {boolean} */
        this.isvisible = false;

        /** @type {string} */
        this.editlinkFunctionality;

        /** @type {string} */
        this.editlinkName;

        /** @type {string} */
        this.editlinkBaseurl;

        /** @type {string} */
        this.editlinkUrl;

        /** @type {gmfUser} */
        this.gmfUser;

        this.scope.$watch(
            () => {
                return this.editlinkActive;
            },
            (newVal) => {
                if (newVal) {
                    const user = this.gmfUser;
                    if (user === undefined) {
                        this.isvisible = false;
                        return;
                    }

                    const authorizedplugins =
            user['functionalities']['authorized_plugins'];
                    this.isvisible =
            authorizedplugins.indexOf(this.editlinkFunctionality) > -1;
                }
            }
        );
    }

    /**
   * @param {string} target
   */
    openDatenerfassung(target) {
        const mapX = this.location.getParam('map_x');
        const mapY = this.location.getParam('map_y');
        const mapZoom = this.location.getParam('map_zoom');

        let redirecturl = this.editlinkBaseurl;

        if (mapX !== undefined && mapY !== undefined) {
            redirecturl += `?map_x=${mapX}&map_y=${mapY}`;
        }

        if (mapZoom !== undefined) {
            redirecturl +=
        redirecturl.indexOf('?') > 0
            ? `&map_zoom=${mapZoom}`
            : `?map_zoom=${mapZoom}`;
        }

        redirecturl +=
      redirecturl.indexOf('?') > 0
          ? `&${this.editlinkUrl}`
          : `?${this.editlinkUrl}`;

        window.open(redirecturl, target);
    }
}

moduleEditlink.controller('MapbsEditlinkController', EditlinkController);

export default moduleEditlink;
